var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"header-oi",attrs:{"elevate-on-scroll":"","height":"90","app":""}},[_c('v-toolbar-title',{staticClass:"text-uppercase"},[_c('Logo')],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }